export enum RequireReasonVisibility {
  All = 'all',
  Negative = 'negative',
  NegativeAndNeutral = 'negative_and_neutral',
}

export interface RootCause {
  id: number | string
  cause: string
}

export enum AutoQaCategoryType {
  Grammar = 'grammar',
  Empathy = 'empathy',
  Greeting = 'greeting',
  Closing = 'closing',
  Readability = 'readability',
  Tone = 'tone',
  Comprehension = 'issue_understanding',
  Solution = 'solution',
  Custom = 'custom',
  Prompt = 'prompt',
}
